import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, InputGroup, Row, Table } from 'react-bootstrap';
import styles from './CompanySelection.module.scss';
import { GET_CONNECTWISE_COMPANY } from '../../../../../../../../../../Utils/GlobalConstants';
import { api } from '../../../../../../../../../../Utils/API';
import loadingGif from "../../../../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import { GenericEmptyStateError, InternalServerError } from '../../../../../../../../../../Utils/StaticMessages/GenericErrorMessages';
import CompanySelectionFilterBox from "./LocalComponents/FilterBox";

const CompanySelection = ({ setMapActionPopup, setDefaultCompanySelected, defaultCompanySelected, setActiveStep, companyName, setCompanyName, buttonCheckstep1, setButtonCheckstep1, setCompanyId, companyData, setCompanyData, Logout }) => {
    let CompanyColumnName = ["", "Company Name", "Company ID", "Types", "Status"];      // Columns of Company table 
    const [searchValueTable, setSearchValueTable] = useState(null);                     // storing searching value in the search input box
    const [searchIconFlag, setSearchIconFlag] = useState(false);                        // to open and close search box
    const searchInputRef = useRef();                                                    // Search Input Box
    const [emptySearch, setEmptySearch] = useState(false);                              // empty search response check state in table during api call to load data
    const [loadingState, setLoadingState] = useState(false);                            // loading state while api is called
    const [status, setStatus] = useState(['active']);                                   // default status as active
    const [showFilterBox, setShowFilterBox] = useState(false);                          // show or hide filter box
    const [filterFlag, setFilterFlag] = useState(true);                                 // to show or hide active filter
    const [isMobile, setIsMobile] = useState(window !== 'undefined' ? window.innerWidth < 768 : false);    // checking for mobile screen or not
    const [showServerErrorFallback, setShowServerErrorFallback] = useState(false);      // show server error fallback UI
    const [allStateSelected, setAllStateSelected] = useState(false);                    // all selected flag


    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // get api for Company mapping data
    async function GetConnectwiseCompanyData(companyName) {
        setLoadingState(true);
        (companyName === undefined || companyName === null) ? companyName = "" : companyName = companyName;
        await api.get(`${GET_CONNECTWISE_COMPANY}?companyName=${companyName}`, config)
            .then(resp => {
                if (resp.status == 204) {
                    setLoadingState(false);
                    setEmptySearch(true);
                    setShowServerErrorFallback(false);
                }

                else if (resp.status == 500) {
                    setLoadingState(false);
                    setShowServerErrorFallback(true);  
                    setEmptySearch(false); 
                }

                else {
                    setLoadingState(false);
                    setEmptySearch(false);
                    setShowServerErrorFallback(false); 
                    setCompanyData(resp.data);
                }

            })
            .catch(error => {
                setLoadingState(false);
                setEmptySearch(false);
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                else {
                   setShowServerErrorFallback(true);
                }
            });
    };

    // On search field value we trigger this function having react debugging after every 800 ms
    useEffect(() => {
        if (searchValueTable !== undefined && searchValueTable !== null) {
            const getData = setTimeout(() => {
                GetConnectwiseCompanyData(searchValueTable)
            }, 800);
            return () => clearTimeout(getData);
        }
    }, [searchValueTable])

    useEffect(() => {
        if (!companyName)
            GetConnectwiseCompanyData();
        if (companyName)
            setSearchValueTable("");
    }, []);

    useEffect(() => {
        if(status && status.length>0 && companyData?.filter((item)=>status.includes(item.status.toLowerCase())).length===0){
            setEmptySearch(true);
            setShowServerErrorFallback(false);
        }
        else{
            setEmptySearch(false);
            setShowServerErrorFallback(false); 
        }
    }, [status,companyData]);

    return (
        <div sx={{ mt: 2, mb: 0 }}>
            <Row className='mb-3'>
                <Col md={8}> <h3 className="mb-5 px-3 mt-2 notes-confirmation">Companies</h3></Col>
                <Col md={4} className='position-relative'>
                    <Row className='mb-3'>

                        <Col md={11} sm={11} xs={11}>
                            <div className="text-right">
                                <InputGroup className="search-input-box search-input-box-xl ">
                                    <InputGroup.Text id="basic-addon2" className="search-input-box-btn">
                                        <span className="searchgrey cpointer"
                                        >
                                            &nbsp;
                                        </span>
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon2"
                                        className="search-input-box-input"
                                        value={searchValueTable}
                                        onChange={(e) => setSearchValueTable(e.target.value)}
                                        ref={searchInputRef}
                                    />
                                    <InputGroup.Text id="basic-addon2" className="search-input-box-btn search-input-box-close"
                                        onClick={() => {
                                            setSearchValueTable("");
                                            setSearchIconFlag(!searchIconFlag);
                                        }}
                                    >
                                        <span className="closebtn">
                                            &nbsp;
                                        </span>
                                    </InputGroup.Text>
                                </InputGroup>
                            </div>
                        </Col> 
                        <Col md={1} sm={1} xs={1}>
                            {!filterFlag && <span className="filter-black cpointer" style={{transform: `translateX(-1.25rem) translateY(0.65rem)`}} id="filterblock" onClick={() => {
                                                                       setShowFilterBox(!showFilterBox);
                                                                    }}></span>}
                            {filterFlag && <span className="filter-black-active cpointer" style={{transform: `translateX(-1.25rem) translateY(0.65rem)`}} onClick={() => { setShowFilterBox(!showFilterBox) }}></span>}  
                        </Col>
                    </Row>
                    <>
                        {showFilterBox && !isMobile &&
                            <CompanySelectionFilterBox
                                searchValueTable={searchValueTable} status={status} setStatus={setStatus} setShowFilterBox={setShowFilterBox} setFilterFlag={setFilterFlag} allStateSelected={allStateSelected} setAllStateSelected={setAllStateSelected} Logout={Logout}
                            />
                        }
                    </>
                </Col>
            </Row>
            {/* loading state */}
            {loadingState &&
                <div className={styles["loading-customers"]}>
                    <img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading ...</p>
                </div>}

            {/* when data is there */}
            {!emptySearch && !loadingState && !showServerErrorFallback &&
                <div className={styles["table-height-adjustment"]}>
                    <Table responsive="md" >
                        <thead className="sticky-top">
                            <tr>
                                {CompanyColumnName.map(th => {
                                    return (<th className={(th === "Status") ? "text-center" : ""}>{th}</th>)
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                companyData && companyData
                                    .filter(item => {
                                        if (status.length === 0) return true;
                                        return status.includes(item.status.toLowerCase());
                                    })
                                    .map((item) => {
                                        return (
                                            <tr key={item.companyId}>
                                                <td><input type='radio'
                                                    style={{ verticalAlign: 'bottom' }}
                                                    id={item.companyId}
                                                    name="companyData"
                                                    checked={defaultCompanySelected === (item.companyId)}
                                                    onChange={() => {
                                                        setDefaultCompanySelected(item.companyId);
                                                        setButtonCheckstep1(true);
                                                        setCompanyName(item.companyName);
                                                        setCompanyId(item.companyId);
                                                    }}
                                                />
                                                </td>
                                                <td>{item.companyName}</td>
                                                <td>{item.companyId}</td>
                                                <td>{item.types}</td>
                                                <td className='text-center'>{item.status}</td>
                                            </tr>
                                        )
                                    })
                            }
                        </tbody>
                    </Table>
                </div>
            }
            {/* empty search result */}
            {emptySearch && !loadingState && !showServerErrorFallback &&
                <div className={styles["no-data-cloud-invoice"]}>
                    <h3 className="mt-4 mb-3">{GenericEmptyStateError}</h3>
                </div>
            }
            {/* server error fallback */}
            {showServerErrorFallback && !loadingState && !emptySearch &&
                <div className={styles["no-data-cloud-invoice"]}>
                   <h3 className="mt-4 mb-3">{InternalServerError}</h3>
                </div>
            }
            <Row className='px-3 pb-0 mt-3'>
                <Col md={6}>
                    <div className='text-small mb-5 mt-3'>
                        <span className='text-strong'>Company name : </span>
                        {companyName}
                    </div>
                </Col>
                <Col md={6}>
                    <div className="btn-wrapper text-right">
                        {(buttonCheckstep1 && !emptySearch) ? <>
                            <Button
                                className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                variant="light"
                                onClick={() => {
                                    setDefaultCompanySelected(null);
                                    setButtonCheckstep1(false);
                                    setCompanyName("");
                                    setMapActionPopup(false);
                                }}
                                sx={{ mr: 1 }} > Cancel </Button>
                            <Button
                                className="px-4 mx-2"
                                onClick={() => {
                                    setActiveStep(1);
                                }}>Proceed</Button></>
                            : <>
                                <Button
                                    className="ml-3 mr-3 btn-border-light w-md-auto col-xs-12"
                                    variant="light"
                                    onClick={() => {
                                        setDefaultCompanySelected(null);
                                        setButtonCheckstep1(false);
                                        setCompanyName("");
                                        setMapActionPopup(false);

                                    }}
                                    sx={{ mr: 1 }} > Cancel </Button>
                                <Button
                                    className="px-4 mx-2 btn-border-light w-md-auto col-xs-12"
                                    variant="light"
                                    disabled >Proceed</Button></>}
                    </div>
                </Col>
            </Row>

        </div>
    )
}

export default CompanySelection
